export const load = () => ({
	title: 'Indow Insert Current Production Queue Timelines',
	h1: 'Current Estimated Lead Times',
	description: 'See our up-to-date production estimates.',
	showTitle: true,
});
